import React, { useState, useEffect } from "react";
import { Table, message } from "antd";
import { useDispatch } from "react-redux";
import { getAllAttemptsByExam } from "../../../apicalls/reports";
import { ShowLoading, HideLoading } from "../../../redux/loaderSlice";
import moment from "moment";

function SingleExam({ exam }) {
  const [reportsData, setReportsData] = useState([]);
  const dispatch = useDispatch();

  const columns = [
    {
      title: "Position",
      dataIndex: "position",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: "User",
      dataIndex: "user",
      render: (text, record) => <>{record.user.name}</>,
    },
    {
      title: "Obtained Marks",
      dataIndex: "obtainedMarks",
      render: (text, record) => <>{record.result.correctAnswers.length}</>,
    },
    {
      title: "Completed Time",
      dataIndex: "completedTime",
      render: (text, record) => (
        <>{moment(record.createdAt).format("MMMM Do YYYY, h:mm:ss a")}</>
      ),
    },
    {
      title: "Verdict",
      dataIndex: "verdict",
      render: (text, record) => <>{record.result.verdict}</>,
    },
  ];

  const fetchLeaderboard = async () => {
    try {
      dispatch(ShowLoading());
      const response = await getAllAttemptsByExam({ examId: exam._id });
      dispatch(HideLoading());
      if (response.success) {
        const sortedData = response.data.sort((a, b) => {
          const marksDiff =
            b.result.correctAnswers.length - a.result.correctAnswers.length;
          if (marksDiff !== 0) return marksDiff;
          return moment(a.createdAt).diff(moment(b.createdAt));
        });
        setReportsData(sortedData);
        message.success(response.message);
      } else {
        message.error(response.message);
      }
    } catch (error) {
      dispatch(HideLoading());
      message.error(error.message);
    }
  };

  useEffect(() => {
    fetchLeaderboard();
    const interval = setInterval(fetchLeaderboard, 15000); // Update every 60 seconds
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exam]);

  return (
    <div>
      <h2>{exam.name} - Leaderboard</h2>
      <Table columns={columns} dataSource={reportsData} rowKey="_id" />
    </div>
  );
}

export default SingleExam;
